<template lang="pug">
div(style={'max-width':'660px'})
  .level
    .level-item
      .level
        .level-left
          //year range
          .level-item
            p <b>Year Range</b> from
            b-select(
              placeholder="Not set",
              @input="(value) => { setStartYearRange(value); }",
              style={ 'margin-left': '5px', 'margin-right': '5px' }
              size='is-small'
            )
              option(
                v-for="option in availableYears",
                :value="option",
                :key="option"
              ) {{ option }}
            p to
            b-select(
              placeholder="Not set",
              @input="(value) => { setEndYearRange(value); }",
              style={ 'margin-left': '5px', 'margin-right': '5px' }
              size='is-small'
            )
              option(
                v-for="option in availableYears",
                :value="option",
                :key="option"
              ) {{ option }}

        .level-right
          //sort option
          .level-item
            p <b>Sort by</b>
            b-select(
              placeholder="Not set",
              style={ 'margin-left': '5px', 'margin-right': '5px' },
              v-model="sortBy"
              size='is-small'
            )
              option(value="year") Year
              option(value="cite") Citation

            p <b>Order by</b>
            b-select(
              placeholder="Not set",
              style={ 'margin-left': '5px', 'margin-right': '5px' },
              v-model='orderBy'
              size='is-small'
            )
              option(value='asc') Ascending
              option(value='desc') Descending
</template>
<script>
import { mapMutations } from "vuex";
import initAvailableDate from "../../../mixins/InitAvailableDate";

export default {
  mixins: [initAvailableDate],

  data: () => ({
    availableYears: [],
  }),

  computed:{
    sortBy:{
      get(){
        return this.$store.state.fetchPaper.sortBy
      },
      set(value){
        this.setSortBy(value)
      }
    },
    orderBy:{
      get(){
        return this.$store.state.fetchPaper.orderBy
      },
      set(value){
        this.setOrderBy(value)
      }
    }
  },

  methods: {
    ...mapMutations("fetchPaper", [
      "setStartYearRange",
      "setEndYearRange",
      "setSortBy",
      "setOrderBy"
    ]),
  },
};
</script>